/**
 * Google AdSense Configuration
 * 
 * Publisher ID: Your unique AdSense publisher ID (ca-pub-XXXXXXX)
 * Ad Slots: Individual ad unit IDs created in your AdSense dashboard
 * 
 * Once your site is verified, create ad units in AdSense and add their slot IDs here.
 */

export const ADSENSE_CONFIG = {
  // Your AdSense publisher ID
  publisherId: 'ca-pub-6227238725528786',
  
  // Enable/disable ads globally (useful for development)
  enabled: process.env.NODE_ENV === 'production' || process.env.REACT_APP_ADS_ENABLED === 'true',
  
  // Ad unit slot IDs - add these after creating ad units in AdSense dashboard
  slots: {
    // Sidebar ads (160x600 skyscraper)
    leftSidebar: '', // Add slot ID after creating in AdSense
    rightSidebar: '', // Add slot ID after creating in AdSense
    
    // Future ad placements
    // headerBanner: '',
    // inContentAd: '',
    // footerBanner: '',
  },
} as const;

// Ad format dimensions
export const AD_FORMATS = {
  skyscraper: { width: 160, height: 600 },
  leaderboard: { width: 728, height: 90 },
  mediumRectangle: { width: 300, height: 250 },
  largeBanner: { width: 320, height: 100 },
} as const;

export type AdSlotKey = keyof typeof ADSENSE_CONFIG.slots;
export type AdFormat = keyof typeof AD_FORMATS;
